import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { TextArea } from '@thoughtspot/radiant-react/widgets/text-area';
import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import styles from './input.module.scss';
const MAX_TEXTAREA_HEIGHT = 104;
const runValidation = (value, validation, compiledRegex) => {
    if (!validation)
        return undefined;
    const { required, requiredError, range, rangeError, regexError, } = validation;
    if (!value) {
        if (required)
            return requiredError ?? '';
        return undefined;
    }
    if (compiledRegex && value && !compiledRegex.test(value))
        return regexError ?? '';
    if (range && value) {
        const num = Number(value);
        if (num < range.min || num > range.max)
            return rangeError ?? '';
    }
    return undefined;
};
export const InputInput = ({ type, value, onChange, onValidationError, onFocus, onBlur, placeholder, disabled, readOnly, maxLength, min: _min, max: _max, validation, }) => {
    const [error, setError] = useState(undefined);
    const textareaRef = useRef(null);
    const compiledRegex = useMemo(() => (validation?.regex ? new RegExp(validation.regex) : null), [validation?.regex]);
    useEffect(() => {
        if (type !== 'textarea')
            return;
        const el = textareaRef.current;
        if (!el)
            return;
        el.style.height = 'auto';
        const next = Math.min(el.scrollHeight, MAX_TEXTAREA_HEIGHT);
        el.style.height = `${next}px`;
        el.style.overflowY =
            el.scrollHeight > MAX_TEXTAREA_HEIGHT ? 'auto' : 'hidden';
    }, [type, value]);
    const handleChange = useCallback((val) => {
        const err = runValidation(val, validation, compiledRegex);
        setError(err);
        onValidationError?.(!!err);
        onChange(val);
    }, [onChange, onValidationError, validation, compiledRegex]);
    if (type === 'textarea') {
        return (React.createElement(TextArea, { value: value, onChange: (e) => handleChange(e.target.value), onFocus: onFocus, onBlur: onBlur, placeholder: placeholder, disabled: disabled, readOnly: readOnly, maxLength: maxLength, hasError: !!error, helperText: error, textAreaRef: textareaRef, textAreaClassName: styles.textarea, className: styles.inputWrapper, rows: 1 }));
    }
    if (type === 'number') {
        return (React.createElement("div", { className: styles.inputWrapper },
            React.createElement(Input.Number, { ariaLabel: placeholder ?? '', value: value, onChange: (val) => handleChange(String(val)), onFocus: onFocus, onBlur: onBlur, disabled: disabled, readOnly: readOnly, hasError: !!error, helperText: error })));
    }
    return (React.createElement("div", { className: styles.inputWrapper },
        React.createElement(Input.Text, { value: value, onChange: (_e, val) => handleChange(val), onFocus: onFocus, onBlur: onBlur, placeholder: placeholder, disabled: disabled, readOnly: readOnly, maxLength: maxLength, hasError: !!error, helperText: error })));
};
//# sourceMappingURL=input.js.map